module.exports = __webpack_public_path__ + "static/img/index-icon3@2x.4ae9918d.png";